import SourceForm from "./Form"

interface Props {
  errors?: Record<string, string[]>
}

export default function NewSource({ errors }: Props) {
  return <SourceForm errors={errors} />
}
